import * as yup from 'yup';

export const validationSchema = yup.object({
  cvv: yup
    .string()
    .required('Ingresa el código de tu tarjeta para continuar')
    .min(3, 'Ingresa el código de tu tarjeta para continuar')
    .max(4, 'Ingresa el código de tu tarjeta para continuar'),
  fees: yup.string().required('Debe seleccionar el número de cuotas'),
  terms: yup
    .boolean()
    .required('Debe aceptar los términos y condiciones')
    .oneOf([true], 'Debe aceptar los términos y condiciones')
});
